<template>
    <div>
        <div class="h-screen w-full">

        </div>
    </div>
</template>
<script>
    export default{
        name: "Page2",
    }
</script>
<style scoped>

</style>